"use client";

import { useEffect, useMemo, useState } from "react";
import SidebarClient from "./SidebarClient";

export default function Sidebar({ session }) {
  const [menus, setMenus] = useState({ primaryMenus: [], secondaryMenus: [], tertiaryMenus: [] });

  useEffect(() => {
    let isMounted = true;

    const fetchMenus = async () => {
      try {
        const res = await fetch("/api/menus", { cache: "no-store" });
        if (!res.ok) return;

        const data = await res.json();
        if (isMounted) {
          setMenus({
            primaryMenus: data.primaryMenus || [],
            secondaryMenus: data.secondaryMenus || [],
            tertiaryMenus: data.tertiaryMenus || [],
          });
        }
      } catch (error) {
        console.error("Failed to fetch sidebar menus", error);
      }
    };

    fetchMenus();

    return () => {
      isMounted = false;
    };
  }, []);

  const links = useMemo(() => {
    if (!session?.user) return [];

    const { userPermissions = {} } = session.user;
  const allowedPrimary = userPermissions.up_primary_menus?.split(",") || [];
  const allowedSecondary = userPermissions.up_secondary_menus?.split(",") || [];
  const allowedTertiary = userPermissions.up_tertiary_menus?.split(",") || [];

  const accessiblePrimaryMenus = menus.primaryMenus.filter((menu) =>
    allowedPrimary.includes(String(menu.pm_pid))
  );

  const mappedLinks = accessiblePrimaryMenus.map((primary) => {
  const filteredSecondary = menus.secondaryMenus
    .filter((s) => String(s.primaryMenuId) === String(primary.pm_pid))
    .filter((s) => allowedSecondary.includes(String(s.sm_id)))
    .sort((a, b) => a.sm_order - b.sm_order)
    .map((sec) => {
      const subSub = menus.tertiaryMenus
        .filter((t) => String(t.tm_secondaryMenuId) === String(sec.sm_id))
        .filter((t) => allowedTertiary.includes(String(t.tm_id)))
        .sort((a, b) => a.tm_order - b.tm_order)
        .map((t) => ({
            id: `t-${t.tm_id}`,
          href: t.tm_href,
          label: t.tm_label,
          icon: t.tm_icon || null,
        }));

      return {
          id: `s-${sec.sm_id}`,
        href: sec.sm_href,
        label: sec.sm_label,
        icon: sec.sm_icon || null,
        submenu: subSub.length ? subSub : null,
      };
    });

  return {
      id: `p-${primary.pm_pid}`,
    href: primary.pm_href,
    label: primary.pm_label,
    icon: primary.pm_icon || null,
    order: primary.pm_order,
    submenu: filteredSecondary.length ? filteredSecondary : null,
  };
});

    return mappedLinks.sort((a, b) => a.order - b.order);
  }, [menus, session]);

  if (!session?.user) return <div>Please log in</div>;

  return <SidebarClient links={links} />;
}
